import React, { useContext } from "react";
import { SubmitBtnContext } from "../../App";
import SubmitBtn from "./SubmitBtn";

const StyledSubmitBtn = props => {
  const { loading, success } = useContext(SubmitBtnContext);
  const {
    variant,
    size,
    href,
    disabled,
    startIcon,
    fullWidth,
    btnColor,
    color,
    onClick,
    btnText,
    children,
    className,
    style
  } = props;

  return (
    <SubmitBtn
      loading={loading}
      success={success}
      variant={variant}
      color={color || btnColor}
      size={size}
      href={href}
      disabled={disabled}
      startIcon={startIcon}
      fullWidth={fullWidth}
      onClick={onClick}
      className={className}
      style={style}
    >
      {btnText || children}
    </SubmitBtn>
  );
};

export default StyledSubmitBtn;
